<template>
    <div :class="['header', 'is-' + color, 'is-display-' + display, {slim: hanging}]">
        <div class="gabarit">
            <router-link class="main-logo" aria-label="Soletanche Bachy" :to="$trl({
                name: 'Home',
                params: {
                    locale: $route.params.locale
                }
            })">
                <Logo :is-white="color === 'white'"/>
                <span class="sea-link-name">Soletanche Bachy</span>
            </router-link>
            <div class="main-content">
                <router-link
                    class="main-link"
                    :to="$trl({
                        name: 'About',
                    })"
                >
                    {{$t('nav.about')}}
                </router-link>
                <router-link
                    class="main-link"
                    :to="$trl({
                        name: 'Solutions',
                    })"
                >
                    {{$t('nav.solutions')}}
                </router-link>
                <router-link
                    class="main-link"
                    :to="$trl({
                        name: 'Projects',
                    })"
                >
                    {{$t('nav.projects')}}
                </router-link>
                <router-link
                    class="main-link"
                    :to="$trl({
                        name: 'Contact',
                    })"
                >
                    {{$t('nav.contact')}}
                </router-link>
            </div>
            <div class="sub-content">
                <LinkHover
                    :type="'router-link'"
                    :to="$trl({
                        name: 'Joinus',
                    })"
                    class="main-link move-link"
                >
                    <span class="default">
                        {{$t('nav.joinus')}}
                    </span>
                    <template v-slot:hover>
                        <span class="hover">
                            {{$t('nav.joinus')}}
                        </span>
                    </template>
                </LinkHover>
                <LinkHover
                    :type="'router-link'"
                    :to="$trl({
                        name: 'News',
                    })"
                    class="main-link move-link"
                >
                    <span class="default">
                        {{$t('nav.news')}}
                    </span>
                    <template v-slot:hover>
                        <span class="hover">
                            {{$t('nav.news')}}
                        </span>
                    </template>
                </LinkHover>
                <SwitchLang
                    class="lang-link last-link move-link"
                    :color="color"
                    :current-lang="$route.params.locale"
                />
            </div>
            <div class="close-text">
                <span class="helper">
                    {{$t('cta.close')}}
                </span>
            </div>
            <BurgerButton :color="color"/>
        </div>
    </div>
</template>

<script>
import Logo from '@/components/Logo'
import BurgerButton from '@/components/BurgerButton'
import SwitchLang from '@/components/SwitchLang'
import LinkHover from '@/components/animation/LinkHover'
import {menu} from '@/store/index.js'
export default {
    components: {
        Logo,
        BurgerButton,
        SwitchLang,
        LinkHover
    },
    props: {
        color: {
            type: String,
            default: 'grey',
            validator: function (direction) {
                return ['grey', 'white', 'red'].indexOf(direction) > -1
            }
        },
        display: {
            type: String,
            default: 'default',
            validator: function (direction) {
                return ['default', 'menu'].indexOf(direction) > -1
            }
        }
    },
    data() {
        return {
            animated: true,
            slim: false,
            lastScroll: 0
        }
    },
    mounted() {
        // window.requestAnimationFrame(this.render)
        window.addEventListener('scroll', this.checkScrollDirection);
    },
    beforeDestroy() {
        this.animated = false
    },
    computed: {
        hanging() {
            return menu.isOpen ? false : this.lastScroll > 20
        }
    },
    methods: {
        checkScrollDirection() {
            var st = window.pageYOffset || document.documentElement.scrollTop
            this.$emit('offset', st)
            if (st > this.lastScroll){
                this.slim = true
            } else {
                this.slim = false
            }
            this.lastScroll = st;
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.header
    height: 75px
    display: flex
    align-items: center
    padding-left: 5.20833%
    padding-right: 5.20833%
    margin-top: 75px
    position: fixed
    left: 0
    right: 0
    top: 0
    z-index: 11
    width: 100vw
    transition: transform .625s
    pointer-events: none
    // &.slim
    //     transform: translateY(-200%)
    @include media-breakpoint-down($lg)
        margin-top: 30px
    @include media-breakpoint-down($sm)
        margin-top: 0
    @include media-breakpoint-up($xxl)
        margin-left: auto
        margin-right: auto
        max-width: 1920px
    @media print
        position: static
        left: initial
        right: initial
        top: initial
        width: auto
        margin-left: 9.6%
        margin-right: 9.6%
        padding-right: 0
        padding-left: 0
        page-break-after: avoid
        break-after: avoid
.gabarit
    display: flex
    align-items: center
    flex: 1
    position: relative
.main-content
    margin-left: 9%
    white-space: nowrap
    transition: opacity 1s 1s
    overflow: hidden
    @include media-breakpoint-down($xl)
        display: none
    @media print
        display: none
    .main-link
        transition: color .3s, transform .3125s ease, opacity .3s
        .slim &
            opacity: 0
            // transform: translateY(-100%)
        &:hover
            will-change: color
            color: #ff2b2a
.main-logo
    overflow: hidden
    pointer-events: all
    .slim &
        pointer-events: none
    .logo-container
        transition: transform .3125s ease, opacity .3s
        .slim &
            opacity: 0
            // transform: translateY(-100%)
            @media print
                transform: translateY(0%)
.sub-content
    margin-left: auto
    display: flex
    position: relative
    transition: opacity .3125s
    pointer-events: all
    @media print
        display: none
    .slim &
        opacity: 0
        pointer-events: none
    .main-link
        border-top: 1px solid rgba(#636772, .15)
        border-bottom: 1px solid rgba(#636772, .15)
        border-left: 1px solid rgba(#636772, .15)
        .default, .hover
            padding-left: 1em
            padding-right: 1em
            display: flex
            align-items: center
        .default
        .hover
            background: #ff2b2a
            color: #FFFFFF
        &+.main-link
            margin-left: 0
        &.last-link
            border-right: 1px solid rgba(#636772, .15)
        @include media-breakpoint-down($lg)
            display: none
    .lang-link
        border-top: 1px solid rgba(#636772, .15)
        border-bottom: 1px solid rgba(#636772, .15)
        border-left: 1px solid rgba(#636772, .15)
        /deep/ .hover-item
            border-left: 1px solid rgba(#636772, .15)
            border-right: 1px solid rgba(#636772, .15)
            border-bottom: 1px solid rgba(#636772, .15)
            width: calc(100% + 2px)
            margin-left: -1px
            &:first-child
                border-top: 1px solid rgba(#636772, .15)
        &+.main-link
            margin-left: 0
        &.last-link
            border-right: 1px solid rgba(#636772, .15)
        @include media-breakpoint-down($lg)
            // display: none
            border: none !important
            padding: 1em 0
.main-link
    font-size: 18px
    font-weight: 500
    height: 75px
    display: inline-flex
    align-items: center
    color: #636772
    text-decoration: none
    pointer-events: all
    white-space: nowrap
    &+.main-link
        margin-left: 1.2em
.header.is-white
    .main-link
        color: #FFF
    .main-content .main-link:hover
        color: #ff2b2a
    .sub-content
        .main-link, .lang-link
            border-top: 1px solid rgba(#FFF, .15)
            border-bottom: 1px solid rgba(#FFF, .15)
            border-left: 1px solid rgba(#FFF, .15)
        .lang-link.last-link
            border-right: 1px solid rgba(#FFF, .15)
.header.is-red
    .main-link
        color: #ff2b2a
    .main-content .main-link:hover
        color: #185aa4
    .sub-content
        .main-link, .lang-link
            border-top: 1px solid #ff2b2a
            border-bottom: 1px solid #ff2b2a
            border-left: 1px solid #ff2b2a
        .lang-link.last-link
            border-right: 1px solid #ff2b2a
.close-text
    position: absolute
    top: 50%
    right: 73px
    font-size: 18px
    font-weight: 500
    color: #ff2b2a
    text-decoration: none
    transform: translateY(-50%)
    overflow: hidden
    pointer-events: none
    padding-right: 16px
    @include media-breakpoint-down($lg)
        display: none

    .helper
        display: block
        transition: transform 1s 0.5s cubic-bezier(.65,0,.25,1)
        transform: translateX(160px)
.move-link
    transition: transform 1s 0.5s cubic-bezier(.65,0,.25,1)
    will-change: transform
.is-display-menu
    .main-content
        transition: opacity .3125s
        opacity: 0
        .main-link
            transition: opacity .3125s, transform .3125s .3125s, color .3125s
    .sub-content
        opacity: 1
        pointer-events: all
    .close-text
        .helper
            transition: transform .3125s
            transform: translateX(0px)
    .move-link
        transition: transform .3125s
        transform: translateX(-160px) translateZ(0)
        @include media-breakpoint-down($lg)
            transform: none
.logo-container
    margin-right: 15%
</style>
